import styled from "styled-components";

interface IContainer {
    amountItems: number;
}

export const Container = styled.ul<IContainer> `
    display: grid;
    gap: 18px 8px;
    grid-template-columns: repeat(1, 1fr);
    margin-bottom: 28px;

    @media(min-width: 380px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media(min-width: 768px) {
        grid-template-columns: repeat(${props => props.amountItems}, 1fr);
        gap: 32px 6px;
    }
`

